import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { strings } from '@client/localization/Localization';
import themeStyles from '@client/shared/styles/theme/theme-styles.scss';
import styles from './pageLoader.scss';

class PageLoaderWithTryAgain extends PureComponent {
  loadingIndicator = () => {
    const { failed } = this.props;
    if (!failed) {
      return (
        <div className={styles.loadingRipple}>
          <div className={styles.loadingCircle}></div>
          <div className={styles.loadingCircle}></div>
        </div>
      );
    }
  };

  tryAgainButton = () => {
    const { tryAgain, failed, onTryAgainClick } = this.props;
    if (tryAgain && failed) {
      return (
        <div className={styles.tryAgainContainer}>
          <p className={styles.errorText}>{strings.somethingWentWrong}</p>
          <button onClick={onTryAgainClick} className={themeStyles.btnPrimary}>
            {strings.tryAgain}
          </button>
        </div>
      );
    }
  };

  render() {
    const { className, wrapComponent } = this.props;
    let classContainer = styles.pageLoader;
    if (className) {
      classContainer += ` ${className}`;
    }

    if (wrapComponent) {
      classContainer += ` ${styles.wrapHeight}`;
    }
    return (
      <div className={classContainer}>
        {this.loadingIndicator()}
        {this.tryAgainButton()}
      </div>
    );
  }
}

PageLoaderWithTryAgain.propTypes = {
  className: PropTypes.string,
  tryAgain: PropTypes.bool,
  failed: PropTypes.bool,
  onTryAgainClick: PropTypes.func,
  wrapComponent: PropTypes.bool,
};

export default PageLoaderWithTryAgain;
